import { useQuery } from '@tanstack/react-query';

import { getAppUpdateStatus } from './api';
import { TAppVersionItem } from './types';


export const useGetApplicationVersion = (currentVersion: string) => {
  return useQuery<TAppVersionItem[], Error, TAppVersionItem[]>({
    queryKey: ['app-update-status', currentVersion],
    queryFn: () => getAppUpdateStatus(currentVersion),
  });
};
